import '.i{position:fixed;}.ssr-plugin'
import '.bn{top:0px;}.ssr-plugin'
import '.bu{left:0px;}.ssr-plugin'
import '.bv{right:0px;}.ssr-plugin'
import '.bw{bottom:0px;}.ssr-plugin'
import '.bx{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.by{z-index:998;}.ssr-plugin'
import '.bz{transition:opacity 0.3s ease;}.ssr-plugin'
import '.c0{height:100vh;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.c1{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.c2{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.c3{padding:1.5rem;}.ssr-plugin'
import '.c4{border-bottom:var(--border-default);}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.az{flex:1;}.ssr-plugin'
import '.c5{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i bn bu bv bw bx by bz"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i bn c0 n v c1 c2 d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d t ae c3 c4 ar"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="az c5 c3"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
